
const mutations = {
  setNumberNotification: (state, payload) => {
    state.numberNotification = payload
  },
  setListNotifications: (state, payload) => {
    state.listNotifications = payload
  },
  setTotalNotifications: (state, payload) => {
    state.totalNotifications = payload
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/notification/mutations.js